import {OptionModel} from "@components/Forms";

export const primitiveTypes = [
    "number",
    "string",
    "boolean"
];

export class QueryDic {
    constructor(paging = {}) {
        if (typeof paging == "object")
            Object.assign(this, paging);
    }

    push(key: string, value: number | string | boolean | object | any[]) {
        this[key] = value;
    }
}

export type IModalService = ng.ui.bootstrap.IModalService;
export type IModalInstanceService = ng.ui.bootstrap.IModalInstanceService;

export class MascotUtils {
    /* COMMON FUNCTIONS */

    // Trim left space
    static ltrim = function (str) {
        return typeof (str) == "string" ? str.replace(/^\s+/, "") : str.toString().replace(/^\s+/, "");
    };

    // Trim right space
    static rtrim = function (str) {
        return typeof (str) == "string" ? str.replace(/\s+$/, "") : str.toString().replace(/\s+$/, "");
    };

    // Trim left, right and double space space
    static trimall = function (str) {
        return MascotUtils.ltrim(MascotUtils.rtrim(str)).replace(/\s{2,}/, " ");
    };

    // Is null or ''
    static IsNullOrWhiteSpace = function (val) {
        return typeof (val) == "undefined" || val == null || val == '';
    };

    // Is null or '0'
    static isNullOrZero = function (val) {
        return MascotUtils.IsNullOrWhiteSpace(val) || val == '0';
    };

    // Is null or '' or ' '
    static isNullOrWhiteSpace = function (val) {
        return typeof (val) == "undefined" || val == null || val == '' || MascotUtils.trimall(val) == '';
    };

    // not undefined
    static isObject = function (obj) {
        return typeof (obj) !== "undefined";
    };

    // Convert a value to number, return def or 0 for default
    static getNumberValue = function (val, def) {
        try {
            if (typeof (val) === "number") {
                return val;
            } else if (typeof (val) === "string") {
                return parseInt(val);
            } else
                return MascotUtils.isObject(def) ? def : 0;
        } catch (err) {
            return MascotUtils.isObject(def) ? def : 0;
        }
    };

    static CheckNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };

    static EmailCheck = function (input) {
        if (!input) return false;
        var emailCheck = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,10}(?:\.[a-z]{2})?)$/;
        if (input.match(emailCheck)) {
            return true;
        }
        ;
        return false;
    };

    static PhoneNumberCheck = function (input) {

        if (!input) return true;
        var phoneCheck = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;
        if (input.match(phoneCheck)) {
            return true;
        }
        return false;
    };

    static CheckLogicDate = function (bDate, aDate) {
        if (bDate > aDate) {
            return false;
        }
        return true;
    };

    static CheckValidDate = function (s) {
        var d = Date.parse(s);
        return !isNaN(d);
    };

    static CheckFolder = function (input) {
        var pattern = /[!@#$%^&*`+\=\[\]{}~;':"\\|,<>\/.?]/;
        if (input.match(pattern)) {
            return false;
        }
        ;
        return true;
    };

    static CheckFile = function (input) {
        var pattern = /[!@#$%^&*`+\ \=\[\]{}~;':"\\|,<>\/?]/;

        if (input.match(pattern)) {
            return false;
        }

        return true;
    };

    static FixHeader = function (target?) {
        setTimeout(() => {
            const table = document.querySelector(target || '#tblList.table') ||
                document.querySelector('table.table-content');
            
            if (table == null) {
                return;
            }

            if (table.querySelectorAll('thead tr').length == 2) {
                const offset = (table.querySelector('thead tr:nth-child(1)').getBoundingClientRect().height) + 'px';
                table.querySelectorAll('thead tr:nth-child(2) th').forEach(x => x.style.top = offset);
            }

            if (table.classList.contains('sticky-header'))
                return;

            table.classList.add('sticky-header');
            //$("#tblList").stickyTableHeaders({scrollableArea: $("#divArea")[0]});
        }, 1000);
    };

    static GetFloatNumberFromString = function (s) {
        var _num = 0;

        if (!MascotUtils.isNullOrWhiteSpace(s)) {
            if (s.indexOf('.') >= 0 && s.indexOf(',') >= 0) {
                s = s.replace('.', '');
                s = s.replace(',', '.');
            } else if (s.indexOf(',') >= 0) {
                s = s.replace(',', '.');
            }

            _num = parseFloat(s);
        }

        return _num;
    };

    static copyToClipboard = async function (selector: string = '.copy-button') {
        const element = document.querySelector(selector);
        if (!element) {
            return;
        }
        const textToCopy = (element as HTMLInputElement).value || element.textContent || "";

        if (!textToCopy) {
            return;
        }

        try {
            await navigator.clipboard.writeText(textToCopy);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    static copyValueToClipboard = async function (text: string) {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };
};

export class ValidatorFactory {
    static CheckPassword(value): boolean {
        return true

        // let isPasswordError = 0;
        // let isPasswordLengthError = false;
        // $("#password-length-condition").removeClass("text-red");
        // $("#password-no-lowercase").removeClass("text-red");
        // $("#password-no-uppercase").removeClass("text-red");
        // $("#password-no-number").removeClass("text-red");
        // $("#password-no-special").removeClass("text-red");
        // if (value.length < 8 || value.length > 40) {
        //     $("#password-length-condition").addClass("text-red");
        //     isPasswordLengthError = true;
        // }
        // if (!value.match(/[a-z]+/)) {
        //     $("#password-no-lowercase").addClass("text-red");
        //     isPasswordError += 1;
        // }
        // if (!value.match(/[A-Z]+/)) {
        //     $("#password-no-uppercase").addClass("text-red");
        //     isPasswordError += 1;
        // }
        // if (!value.match(/[0-9]+/)) {
        //     $("#password-no-number").addClass("text-red");
        //     isPasswordError += 1;
        // }
        // if (!value.match(/[!@#$%^&*()_+=\[{\]};:<>|./?,-]+/)) {
        //     $("#password-no-special").addClass("text-red");
        //     isPasswordError += 1;
        // }
        // return !(isPasswordError > 1 || isPasswordLengthError);
    }

}


export const ProductTags = [
    {
        Type: 1,
        Name: "New"
    },
    //{
    //    Type: 2,
    //    Name: "Outlet"
    //}
];

export const SlideEffect = [
    {
        Type: 1,
        Name: "Show"
    },
    {
        Type: 2,
        Name: "Fade"
    },
    {
        Type: 3,
        Name: "Slide down"
    }
];

export const AvoidDealerCode = [
    "checkout",
    "order",
    "admin",
    "search",
    "user",
    "home",
    "category",
    "basket",
    "product"
];

export const booleanOptionData: OptionModel[] = [
    {
        value: 1,
        text: 'Yes'
    },
    {
        value: 0,
        text: 'No'
    }
];

export const CouponRestriction = [
    {
        Id: 0,
        Name: 'All Products'
    },
    {
        Id: 1,
        Name: 'Product SKU'
    },
    {
        Id: 2,
        Name: 'Product Group'
    },
    {
        Id: 3,
        Name: 'Category'
    },
    {
        Id: 4,
        Name: 'Product Quantity'
    },
    {
        Id: 5,
        Name: 'Order Amount'
    }
];
export const CouponType = [
    {
        Id: 0,
        Name: '%'
    },
    {
        Id: 1,
        Name: 'Amount'
    }
];
export const CouponFreeLogoType = [
    {
        Id: 0,
        Name: '%'
    },
    {
        Id: 2,
        Name: 'Free Logo'
    }
];

export const SpecialType = [
    {
        Id: 0,
        Name: '%'
    },
    {
        Id: 2,
        Name: 'Amount'
    }
];

export const OrderReason = [
    {
        Id: '0',
        Name: "Any"
    },
    {
        Id: '1',
        Name: "Internet Promotion"
    },
    {
        Id: '2',
        Name: "Introduced by another user"
    }
];

export const CouponActivation = [
    {
        Id: 2,
        Name: 'Any'
    },
    {
        Id: 0,
        Name: 'Inactivated'
    },
    {
        Id: 1,
        Name: 'Activated'
    }
];

export const CouponExpiration = [
    {
        Id: 2,
        Name: 'Any'
    },
    {
        Id: 0,
        Name: 'Not expired yet'
    },
    {
        Id: 1,
        Name: 'Expired'
    }
];


export const ActiveStatus = [
    {
        Id: 2,
        Title: 'All'
    },
    {
        Id: 1,
        Title: 'Active'
    },
    {
        Id: 0,
        Title: 'Inactive'
    }
];

export const CouponUsableTypes = [
    {
        Id: 0,
        Name: 'Unlimited'
    },
    {
        Id: 1,
        Name: 'Limit'
    },
    {
        Id: 2,
        Name: 'Limit For Each Customer'
    }
];

export const CouponApplyToTypes = [
    {
        Id: 0,
        Name: 'All'
    },
    {
        Id: 1,
        Name: 'Category'
    },
    {
        Id: 2,
        Name: 'Collection'
    },
    {
        Id: 3,
        Name: 'Product'
    }
];


export const StandAloneStatus = [
    {
        Id: 2,
        Title: 'All'
    },
    {
        Id: 0,
        Title: 'No'
    },
    {
        Id: 1,
        Title: 'Yes'
    }
];
export const ShowPercentageSettings = [
    {
        Value: false,
        Text: "No"
    },
    {
        Value: true,
        Text: "Yes"
    }
];
export const ApplyEndDateTypes = [
    {
        Value: false,
        Text: "No End Date"
    },
    {
        Value: true,
        Text: "Apply End Date"
    }
];
export const StandAloneSettings = [
    {
        Value: false,
        Text: "No"
    },
    {
        Value: true,
        Text: "Yes"
    }
];

export const ActiveStatusSettings = [
    {
        Value: true,
        Text: 'Active'
    },
    {
        Value: false,
        Text: 'Inactive'
    }
];

export const SelectSortOptions = [
    {
        Value: 0,
        Text: 'Oldest'
    },
    {
        Value: 1,
        Text: 'Newest'
    }
];

export const PaymentMethodName = {
    0: 'Epay',
    1: 'Epay',
    5: 'Epay',
    2: 'Buy On Credit',
    3: 'iDeal',
    4: 'PayPal',
    6: 'In Store',
    7: 'MSP',
    8: 'External',
    9: 'Manual'
};

export const PaymentMethodType = {
    "Epay": 0,
    "Sofort": 1,
    "Buy On Credit": 2,
    "iDeal": 3,
    "PayPal": 4,
    "PayInAdvance": 5,
    "In Store": 6,
    "MSP": 7,
    "External": 8,
    "Manual": 9
};


export function DisableSuggestPassword(idTextBox) {
    // let textBox = "#" + idTextBox;
    // $(textBox).attr("readonly", true);
    // $(textBox).removeAttr('readonly');
}


export function range(lowEnd, highEnd) {
    var arr = [],
        c = highEnd - lowEnd + 1;
    while (c--) {
        arr[c] = highEnd--;
    }
    return arr;
}


export function createRandomId() {
    return Math.random().toString(36).substring(2, 9)
}

export function toMB(fileSizeInBytes: number) {
    return (fileSizeInBytes / (1024 * 1024));
}

export function mbToB(mb: number) {
    return mb * (1024 * 1024);
}

export function checkAllChildren(node: OptionModel, isChecked: boolean) {
    if (!node.children?.length) {
        return;
    }

    node.children.forEach((child) => {
        child.checked = isChecked;
        checkAllChildren(child, isChecked);
    });
}

export function flattenDeep(options: OptionModel[]): OptionModel[] {
    return options.flatMap(x => {
        const childItems = x.children ? flattenDeep(x.children) : [];
        return [
            x,
            ...childItems
        ];
    });
}

export function flattenDeepByKey<T>(options: T[], key: string): T[] {
    return options.flatMap(x => {
        const childItems: T[] = x[key] ? flattenDeepByKey(x[key], key) : [];
        return [
            x,
            ...childItems
        ];
    });
}

export function getDecimal(value: string | number | null | undefined): number {
    const decimal = Number(value ?? 0);
    return Number.isFinite(decimal) ? decimal : 0;
}
